import moment from "moment";
export function utcToLocal(date) {
    var offset = moment().utcOffset();
    date = moment.utc(date).utcOffset(offset);
    return date;
}